import * as Types from './../Models/AOIModel';
// import { EnumTypes } from './../Models/EnumTypes/PageEnumTypes';
import * as AOIActions from 'Redux/Actions/AOIActions';
import * as AOIConnector from './../Connectors/AOIConnector';

export { Types, AOIConnector as Connector, AOIActions as Actions };



// WEBPACK FOOTER //
// ./src/Modules/AOIModule.ts